<template>
  <form class="usage-terms-form"
        @submit.prevent="createUsageTerm">

    <div class="usage-terms-form-header">
      <v-text-field v-model="form.name"
                    v-validate="'required'"
                    :hide-details="true"
                    :error-messages="errors.collect($t('message.generics.message.name'))"
                    :label="$t('message.termsOfUse.message.name')"
                    name="Nome">
        <template v-slot:append>
          <i class="mdi mdi-help-circle-outline pointer"
             v-tooltip="$t('message.termsOfUse.message.tooltipName')"></i>
        </template>
      </v-text-field>
      <v-text-field v-model="form.title"
                    :maxlength="40"
                    :hide-details="true"
                    :label="$t('message.termsOfUse.message.titleLabel')"
                    name="Título">
        <template v-slot:append>
          <i class="mdi mdi-help-circle-outline pointer"
             v-tooltip="$t('message.termsOfUse.message.tooltipTitle')"></i>
        </template>
      </v-text-field>
    </div>

    <html-editor class="usage-terms-form-term"
                 v-model="form.content"
                 :label="$t('message.termsOfUse.message.termsOfUse')"
                 :help="$t('message.termsOfUse.message.tooltipTermsOfUse')" />

    <usage-terms-form-opt-in :admin="admin"
                             :value="optinVal"
                             @input="setOptinVal" />

    <div class="usage-terms-form-actions">
      <button type="submit"
              class="btn btn-extra-round btn-primary ">
        {{$t('message.generics.message.save')}}
      </button>
    </div>
  </form>
</template>

<script>
  import HtmlEditor from '@components/form/HtmlEditor.vue'
  import UsageTermsFormOptIn from '@views/usage-terms/components/UsageTermsFormOptIn'

    export default {
        components: {
          HtmlEditor,
          UsageTermsFormOptIn
        },

        data() {
            return {
              form: {
                name: undefined,
                title: undefined,
                content: undefined,
                optinText: undefined,
                optionalOptinAccepting: false
              },
              optinVal: {
                text: undefined,
                optionalOptinAccepting: false
              }
            }
        },

        props: {
          item: {
            type: Object
          },
          admin: {
            type: Boolean,
            default: false
          }
        },

        computed: {
          isEdit() {
            return !!this.item
          },
          isAdmin() {
            return this.$store.state.users.admin && !this.$store.state.users.user
          },
          user() {
            return this.$store.state.users.user
          }
        },

        methods: {
          async createUsageTerm() {
            const isValid = await this.$validator.validateAll();

            if(isValid) {
              try {
                const userId = this.isAdmin ? 0 : this.user.id

                if(this.isEdit) {
                  await this.$api.usageTerms.edit({...this.form, userId, usageTermId: this.item.id})
                } else {
                  await this.$api.usageTerms.create({ ...this.form, userId })
                }

                 this.$router.push(this.isAdmin ? '/admin/termos-de-uso' : '/termos-de-uso');
              } catch (error) {
                console.log(error)
              }
            }
          },
          setOptinVal(value) {
            this.optinVal = value
            this.form.optinText = value.text
            this.form.optionalOptinAccepting = value.optionalOptinAccepting
          }
        },

        created() {
          if(this.isEdit) {
            this.form = {
              name: this.item.name,
              title: this.item.title,
              content: this.item.content,
              optinText: this.item.optinText,
              optionalOptinAccepting: this.item.optionalOptinAccepting
            }

            this.optinVal = {
              text: this.item.optinText,
              optionalOptinAccepting: this.item.optionalOptinAccepting
            }
          }
        },

        beforeDestroy() {
        },
    }
</script>

<style lang="scss" scoped>
.usage-terms-form {
  margin: 5px 100px 0;
  padding-bottom: 50px;

  .usage-terms-form-header {
    display: flex;
    margin-bottom: 50px;

    i {
      color: #707070;
    }

    .v-input {
      margin-right: 100px !important;

      &:last-child {
        margin-right: 0 !important;
      }
    }
  }

  .usage-terms-form-term {
    margin-bottom: 15px;
  }

  .usage-terms-form-actions {
    display: flex;
    justify-content: center;

    .btn {
      width: 200px;
      flex-shrink: 0;
      margin-right: 50px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
